import styled from 'styled-components';
import PrivateBathSvg from '../../assets/amenities/private-bath.svg';

const PrivateBathIcon = styled(PrivateBathSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default PrivateBathIcon;
